import { PAGE_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TPageSelector, TEqualityFunction } from '../types';

export const usePageSelector = <TSelected>(selector: TPageSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof PAGE_REDUCER>(PAGE_REDUCER, selector, equalityFn);
};
